import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { Template } from '../models';
import { TemplateActions, TemplateActionTypes } from '../actions';

export interface TemplateState extends EntityState<Template> {
  totalCount: number;
  query: QueryParamsModel;
  pageLoading: boolean;
  actionLoading: boolean;
  showInitWaitingMessage: boolean;
  error: any;
}

export const adapter: EntityAdapter<Template> = createEntityAdapter<Template>({
  selectId: (template) => template.id,
});

export const initialTemplateState: TemplateState = adapter.getInitialState({
  totalCount: 0,
  query: new QueryParamsModel({}),
  pageLoading: false,
  actionLoading: false,
  showInitWaitingMessage: true,
  error: null,
});

export function templateReducer(
  state = initialTemplateState,
  action: TemplateActions,
): TemplateState {
  switch (action.type) {
    case TemplateActionTypes.ToggleTemplatePageLoading:
      return { ...state, pageLoading: action.payload.pageLoading };

    case TemplateActionTypes.ToggleTemplateActionLoading:
      return { ...state, actionLoading: action.payload.actionLoading };

    case TemplateActionTypes.LoadTemplatePage:
      return adapter.addMany(action.payload.templates, {
        ...initialTemplateState,
        totalCount: action.payload.totalCount,
        query: action.payload.query,
        showInitWaitingMessage: false,
      });

    case TemplateActionTypes.CancelTemplatePage:
      return { ...state, query: new QueryParamsModel({}) };

    case TemplateActionTypes.CreateTemplate:
      return adapter.addOne(action.payload.template, state);

    case TemplateActionTypes.UpdateTemplate:
      return adapter.updateOne(action.payload.template, state);

    case TemplateActionTypes.ThrowTemplateError:
      return {
        ...state,
        pageLoading: false,
        actionLoading: false,
        error: action.payload.error,
      };

    case TemplateActionTypes.ClearTemplateError:
      return { ...state, error: null };

    default:
      return state;
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
